import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import { ProductDetailsPhotosSkeleton } from '../ProductDetailsPhotos';

import s from './ProductDetailsInfo.sss';

interface Props {
  className?: string,
}

export const ProductDetailsInfoSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <article className={s.product}>
        <section className={s.mainSection}>
          <div className={s.gallery}>
            <ProductDetailsPhotosSkeleton />
          </div>

          <div className={s.mainInfo}>
            <Skeleton
              width='80%'
              height='20px'
            />

            <Skeleton
              width='60%'
              height='20px'
            />

            <Skeleton
              width='50%'
              height='20px'
            />
          </div>
        </section>
      </article>
    </div>
  );
};
